import { NovaGraphQL } from '@nova/types';
import { useNovaQuery } from 'owa-apollo-hooks';

export const novaGraphQL: NovaGraphQL = {
    // Note: Use the useManagedQuery hook here because the Apollo client in OWA is configured to use no-cache by default
    useLazyLoadQuery: useNovaQuery,
    useSubscription: (
        subscription,
        options?: {
            variables?: {
                [name: string]: unknown;
            };
            onSubscriptionData?: (options: {
                subscriptionData: {
                    error?: Error;
                    data?: {};
                };
            }) => void;
        }
    ) => {
        return;
    },
};
